import React from "react";
import { useSelector } from "react-redux";
import { Alert, Button, Col, Row, Typography, Layout, Grid } from "antd";

import "../../styles/login/login.scss";
import ouPic from "./login-background.jpg";
import upLogo from "./up-logo.png";
import TestServer from "../../components/EnvironmentIdentifier/TestServer";

const { useBreakpoint } = Grid;
const { Title, Paragraph } = Typography;
const { Content, Footer } = Layout;

const LoginPage = () => {
  const screens = useBreakpoint();
  const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";
  const maintenanceEnabled = useSelector(
    (state) => state.generalSlice.maintenanceEnabled,
  );

  const authError = new URLSearchParams(window.location.search).get("auth_error");
  const errorMessage =
    authError === "unauthorized_domain"
      ? "Access is restricted to @upou.edu.ph accounts. Please use your UPOU Google account."
      : authError === "oauth_failed"
      ? "Google sign-in failed. Please try again."
      : null;

  const handleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google/redirect`;
  };

  return (
    <>
      {!isProduction && <TestServer />}
      <Layout className="login-layout">
        <Content className="login-content">
          <Row className="login-container" wrap>
            <Col xs={24} md={10} className="login-left">
              <div className="login-title">
                <img src={upLogo} className="login-logo" alt="UP Logo" />
                <div>
                  <p className="login-upou">
                    University of the Philippines Open University
                  </p>
                  <Title level={3} style={{ margin: 0, color: "#862633" }}>
                    PIVOT
                  </Title>
                </div>
              </div>

              <div className="login-text">
                <Title
                  level={1}
                  style={{ color: "#862633", fontWeight: "700", margin: 0 }}
                >
                  Welcome to PIVOT
                </Title>
                <Paragraph
                  style={{
                    color: "#862633",
                    fontSize: "18px",
                    fontWeight: "400 !important",
                  }}
                >
                  Platform for Information, Visibility, and Organizational Tasks
                </Paragraph>
                <Paragraph>
                  — a comprehensive system designed to facilitate document
                  tracking and request management.
                </Paragraph>
                <Paragraph>
                  Providing a structured and transparent framework, PIVOT
                  enhances efficiency, improves visibility, and streamlines
                  organizational workflows.
                </Paragraph>
                <Paragraph strong>
                  Login below using your UPOU Google account.
                </Paragraph>

                {maintenanceEnabled && (
                  <Alert
                    type="warning"
                    message="We are currently under maintenance. Please come back later."
                    showIcon
                    style={{ marginBottom: 12 }}
                  />
                )}

                {errorMessage && (
                  <Alert
                    type="error"
                    message={errorMessage}
                    showIcon
                    style={{ marginBottom: 12 }}
                  />
                )}

                <Button
                  type="primary"
                  size="large"
                  className="login-button"
                  onClick={handleLogin}
                  block={screens.xs}
                >
                  Log in with Google
                </Button>
              </div>

              <Footer className="login-footer">
                © Developed by the UPOU ICT Development Office. All rights reserved {new Date().getFullYear()}.
              </Footer>
            </Col>
            <Col xs={0} md={14} className="login-right">
              <img src={ouPic} className="login-img" alt="Background" />
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default LoginPage;
